/* eslint-disable */
import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
import apiCallManager from '../assets/js/apiCallManager.js'

// 全局防重复提示标志
let isTokenExpiredHandling = false

// 统一的token过期处理函数
function handleTokenExpired() {
  // 如果已经在处理中，直接返回
  if (isTokenExpiredHandling) {
    return
  }
  
  // 设置处理标志
  isTokenExpiredHandling = true
  
  // 清除所有本地存储
  localStorage.removeItem('mental_token')
  localStorage.removeItem('mental_user_info')
  localStorage.removeItem('mental_school_list')
  localStorage.removeItem('mental_current_school_id')
  localStorage.removeItem('mental_password')
  localStorage.removeItem('mental_account')
  
  // 显示提示信息
  Message.warning({
    message: 'token已过期，请重新登录',
    duration: 2000,
    onClose: () => {
      // 重置标志
      isTokenExpiredHandling = false
    }
  })
  
  // 跳转到登录页
  setTimeout(() => {
    router.push({ name: 'Login' })
    // 重置标志
    isTokenExpiredHandling = false
  }, 500)
}

/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
// export const TIME_OUT = 60000; // 请求超时时间
// export const ERR_OK = true; // 请求成功返回状态，字段和后台统一
// export const baseUrl = 'https://model.amarachat.com:19010/api/school';
// export const schoolUrl = 'https://model.amarachat.com:19010/api/school/manage';
// export const studentUrl = 'https://model.amarachat.com:19010/api/school/student';
// export const platUrl = 'https://model.amarachat.com:19010/api/plat/guest';
// // export const aiUrl = 'https://chat.ai-lingxin.com:38012';
// export const aiUrl = 'https://model.amarachat.com:19010';
export const TIME_OUT = 60000; // 请求超时时间
export const ERR_OK = true; // 请求成功返回状态，字段和后台统一

export const baseUrl = 'https://www.ai-lingxin.com:6443/api/school';
export const schoolUrl = 'https://www.ai-lingxin.com:6443/api/school/manage';
export const studentUrl = 'https://www.ai-lingxin.com:6443/api/school/student';
export const platUrl = 'https://www.ai-lingxin.com:6443/api/plat/guest';
export const teamtestUrl = 'https://www.ai-lingxin.com:6443/api/teamtest/manage';
export const aiUrl = 'https://www.ai-lingxin.com:6443';


// export const aiUrl = 'https://www.ai-lingxin.com:6443';
// 请求超时时间
axios.defaults.timeout = TIME_OUT
// 封装请求拦截
axios.interceptors.request.use(
  config => {
    // 生成请求标识（用于日志记录）
    const requestKey = apiCallManager.generateRequestKey(
      config.url,
      config.method,
      config.data || config.params
    );

    const defaultToken = localStorage.getItem('mental_token');
    const educationToken = localStorage.getItem('mental_token1');
    let token = defaultToken;
    if (config && config.headers && config.headers['X-Use-Edu-Token']) {
      token = educationToken;
      delete config.headers['X-Use-Edu-Token'];
    }
    // 对于 FormData，不设置 Content-Type，让浏览器自动生成 multipart/form-data 边界
    const isFormData = (config && config.data) instanceof FormData;
    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }
    if (token != null) {
      // 兼容旧接口
      config.headers['token'] = token;
      // 满足新接口规范
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 添加请求标识到config中（仅用于日志记录）
    config.requestKey = requestKey;

    // 创建一个Promise并添加到管理器中（仅用于状态跟踪）
    const requestPromise = new Promise((resolve, reject) => {
      config._resolveRequest = resolve;
      config._rejectRequest = reject;
    });

    apiCallManager.addPendingRequest(requestKey, requestPromise);

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 封装响应拦截，判断token是否过期
axios.interceptors.response.use(
  response => {
    // 处理请求完成
    if (response.config && response.config.requestKey) {
      if (response.config._resolveRequest) {
        response.config._resolveRequest(response);
      }
    }

    let { data } = response
    // 检查业务状态码
    if (data && data.code === -2) { // 如果后台返回的错误标识为token过期，则重新登录
      handleTokenExpired()
      return Promise.reject({code: -2, msg: 'token已过期，请重新登录'});
    } else if (data && data.code === -4) {
      const info = JSON.parse(localStorage.getItem('mental_user_info') || '{}');
      info.must_change_password = true;
      localStorage.setItem('mental_user_info', JSON.stringify(info));
      router.replace({name:'Password', query: {from: 'login'}});
      return Promise.reject({code: -4, msg: '需要修改密码'});
    } else {
      return Promise.resolve(response)
    }
  },
  error => {
    // 处理请求失败
    if (error.config && error.config.requestKey) {
      if (error.config._rejectRequest) {
        error.config._rejectRequest(error);
      }
    }

    // 检查是否是401未授权错误（token过期）
    if (error.response && error.response.status === 401) {
      handleTokenExpired()
      return Promise.reject({code: -2, msg: 'token已过期，请重新登录'});
    }

    // 检查响应数据中的业务状态码
    if (error.response && error.response.data && error.response.data.code === -2) {
      handleTokenExpired()
      return Promise.reject({code: -2, msg: 'token已过期，请重新登录'});
    }

    if (error.code === 'ECONNABORTED') {
      Message.error({
        message: '请求超时，请刷新页面！',
        duration: 3000
      });
      // 可以根据需要执行其他操作，例如通知用户或重试请求等
    } else {
      console.error('请求失败', error);
    }
    return Promise.reject(error)
  }
)
export function get(url, params) {
  return axios.get(url, {
    params: params
  }).then(res => {
    return res.data;
  });
}

export function post(url, params = {}, config = {}) {
  return axios.post(url, params, config).then(res => {
    return res.data;
  });
}
// 专用于文件下载（blob）
export function postBlob(url, params) {
  return axios.post(url, params, { responseType: 'blob' }).then(res => {
    return res.data;
  });
}
// 返回完整响应（含headers）的blob请求
export function postBlobResponse(url, params) {
  return axios.post(url, params, { responseType: 'blob' }).then(res => res);
}
export function deletes(url, params) {
  // 确保DELETE请求配置正确
  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  };
  
  // 如果有参数，添加到请求体中
  if (params) {
    config.data = params;
  }
  
  return axios.delete(url, config).then(res => {
    return res.data;
  });
}

export function put(url, params) {
  return axios.put(url, params).then(res => {
    return res.data;
  });
}

export function patch(url, params) {
  return axios.patch(url, params).then(res => {
    return res.data;
  });
}
export default axios



// WEBPACK FOOTER //
// ./src/service/request.js